var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Input } from '../../../../Forms/Input/Input';
import { ActionRow } from './components/ActionRow';
import { i18n } from '@lingui/core';
import { x } from '@xstyled/styled-components';
import { RowLayout } from './styles';
import { getTranslatedValue } from './utils';
var ManageColumnForm = function (_a) {
    var columns = _a.columns, columnsConfigValues = _a.columnsConfigValues, setColumnsConfigOptions = _a.setColumnsConfigOptions, handleDragEnd = _a.handleDragEnd;
    var _b = useState(''), searchedValue = _b[0], setSearchedValue = _b[1];
    var onChangeInputValue = useCallback(function (e) {
        setSearchedValue(e.target.value);
    }, [setSearchedValue]);
    var clear = useCallback(function () {
        setSearchedValue('');
    }, [setSearchedValue]);
    return (_jsxs(x.div, { children: [_jsx(Input, { icon: "search", type: "text", value: searchedValue, placeholder: i18n._({ id: 'manageColumn.searchPlaceholder', message: 'Find column...' }), onChange: onChangeInputValue, onClear: clear, variant: "gray" }), _jsx(DragDropContext, { onDragEnd: handleDragEnd, children: _jsx(Droppable, { droppableId: "droppable", direction: "vertical", isCombineEnabled: false, ignoreContainerClipping: false, isDropDisabled: !!searchedValue, children: function (droppableProvided) { return (_jsx(x.div, __assign({ h: "400px", overflowY: "scroll", mt: "20px", ref: droppableProvided.innerRef }, droppableProvided.droppableProps, { children: columns === null || columns === void 0 ? void 0 : columns.map(function (column, index) {
                            var translatedValue = getTranslatedValue(column);
                            var isVisible = translatedValue &&
                                translatedValue.toLocaleLowerCase().includes(searchedValue.toLocaleLowerCase()) &&
                                !column.alwaysOn;
                            return (_jsx(Draggable, { draggableId: column.name, index: index, isDragDisabled: !!searchedValue, children: function (_a) {
                                    var innerRef = _a.innerRef, draggableProps = _a.draggableProps, dragHandleProps = _a.dragHandleProps;
                                    return (_jsx(RowLayout, __assign({ "$isVisible": isVisible }, draggableProps, { ref: innerRef }, dragHandleProps, { children: _jsx(ActionRow, { column: column, columnsConfigValues: columnsConfigValues, setColumnsConfigOptions: setColumnsConfigOptions, translatedValue: translatedValue }, index) })));
                                } }, column.name));
                        }) }))); } }) })] }));
};
export default ManageColumnForm;
